<body>
  <div class="grid">
    <div class="grid-item-1">
        <p class="p0">HUB Controller</p><p class="p1">&#9415;</p>
    </div>
    <div class="grid-item-2"></div>
    <div class="grid-item-3"><p class="p2">Happy<br>Saving.</p></div>
    <div class="grid-item-4"></div>
    <div class="grid-item-5">
        <p class="p3">Thanks for your details!<br><p class="p4">We will be in contact shortly about your installation</p></p>
    </div>
    <div class="grid-item-6"><p class="p5">Smart</p><p class="p6">Thermostat</p></div>
    <div class="grid-item-7"></div>
    <div class="grid-item-8"></div>
    <div class="grid-item-9"></div>
  </div>
</body>
